export const ISSUER = {
  name: "Blu Lodge Pvt ltd",
  address: "Dharumavantha Magu - 20128 - K.Malé, Maldives (MALDIVE)",
  vat: "1179844",
  email: "info@blulodgemaldives.com",
  phone: "+9609356335",
  web: "https://www.blulodgemaldives.com",
};

export const BANK = { bank: "INTESA SAN PAOLO", iban: "IT76Q0306903018100000007000", bic: "BCITITMM" };

export const LEGAL_NOTE =
  "Senza valenza fiscale ai sensi dell'art. 21 DPR 633/72 e s.m., salvo per i soggetti non titolari di partita IVA, in regime dei minimi o forfetario o non residenti.";

export const KIND_LABEL = { acconto: "Acconto", saldo: "Saldo", altro: "Altro" };

export const lineCalc = (l) => {
  const imp = Number(l.qty || 0) * Number(l.unit || 0);
  const base = imp - Number(l.discount || 0);
  const iva = (base * Number(l.vat || 0)) / 100;
  return { imp, base, iva, importo: base + iva };
};

export const calcTotals = (lines) => {
  const t = (lines || []).reduce((a, l) => { const c = lineCalc(l); return { imponibile: a.imponibile + c.base, imposta: a.imposta + c.iva }; }, { imponibile: 0, imposta: 0 });
  return { ...t, total: t.imponibile + t.imposta };
};

export const fmtDateIt = (d) => (d ? d.slice(0, 10).split("-").reverse().join("/") : "");

export const descFor = (kind, guest) => `${kind === "saldo" ? "Saldo" : kind === "acconto" ? "Acconto" : ""} soggiorno Maldive ${guest}`.trim();

// Bozza fattura precompilata da una prenotazione (o dalle camere di un gruppo)
export function draftFromBookings(rooms) {
  const b = rooms[0];
  const sum = (k) => rooms.reduce((a, r) => a + Number(r[k] || 0), 0);
  const guest = `fam. ${b.guest_surname || b.guest_name || ""}`.trim();
  const amounts = { acconto: sum("acconto"), saldo: sum("saldo"), altro: sum("total_amount") };
  return {
    number: "", date: new Date().toISOString().slice(0, 10), kind: "acconto",
    booking_id: rooms.length === 1 ? b.id : null, group_id: b.group_id || null,
    guest_name: guest,
    client: { name: b.origine && b.origine !== "Diretto" ? b.origine : `${b.guest_name || ""} ${b.guest_surname || ""}`.trim(), address: "", vat: "", cf: "", sdi: "", phone: "" },
    lines: [{ description: descFor("acconto", guest), qty: 1, unit: amounts.acconto, discount: 0, vat: 0 }],
    payment_method: "Bonifico Bancario", notes: "", _amounts: amounts,
  };
}
